import { useEffect, useState } from 'react'

import { getRequestSummary } from '../../../../../../api'
import { EMPTY_OBJECT } from '../../../../../../constants/common'
import { useApi, useInitData } from '../../../../../../hooks'
import {
  getRequestSummaryEmptyWidgetData,
  getRequestSummaryWidgetData,
} from '../../RequestProfileWidgetAISummary.utils'

export function useRequestProfileWidgetAISummaryData({
  isEnabled = true,
  requestData,
}) {
  const api = useApi()

  const { ai_features: aiFeatures } = useInitData()

  const requestId = requestData?.id
  const requestUpdatedAt = requestData?.updatedAt

  const hasAiSummary = aiFeatures?.request_summary_generation

  const [summaryData, setSummaryData] = useState(null)

  async function loadSummary({ options } = EMPTY_OBJECT) {
    return getRequestSummary({ id: requestId, options })
      .then(response => {
        if (response) {
          setSummaryData(getRequestSummaryWidgetData(response.data))
        }
      })
      .catch(() => {
        setSummaryData(getRequestSummaryEmptyWidgetData())
      })
  }

  function patchSummaryData(patch) {
    setSummaryData(prevSummaryData => ({
      ...(prevSummaryData ?? EMPTY_OBJECT),
      ...patch,
    }))
  }

  useEffect(() => {
    if (isEnabled && hasAiSummary && requestId) {
      api.call(loadSummary)
    }

    return () => {
      api.abort()
    }
  }, [hasAiSummary, isEnabled, requestId, requestUpdatedAt])

  return {
    patchSummaryData,
    summaryData,
  }
}
